var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-view"},[_c('mt-header',{attrs:{"fixed":"","title":"查看报告"}},[_c('router-link',{attrs:{"slot":"left","to":"/tdShared/tdOrderDetail"},slot:"left"},[_c('mt-button',{attrs:{"icon":"back"}})],1)],1),_vm._v(" "),_vm._l((_vm.imageList),function(item,index){return _c('img',{key:index,attrs:{"src":item,"width":"100%"}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ade9cb3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/others/fileView.vue
// module id = null
// module chunks = 